import './header.scss'

import {MediaQuery} from '@codeurs/front'
import {HeaderType} from 'campagne/types'
import React, {Fragment, FunctionComponent, useEffect, useState} from 'react'
import {style} from 'util/campagne/style'
import {useLanguage} from 'util/i18n'
import {Link} from 'util/link'
import {NavItem} from 'views/campagne/theme/navitem'
import {ButtonPrimary, ButtonSecondary} from 'views/ui/Button'
import {ReactComponent as LogoNl} from '../../../assets/images/logo_nl.svg'
import {useAutohide} from '../../../util/autohide'
import {HeaderPopup} from '../../layout/header/HeaderPopup'

const styles = style('header', ['row', 'logo', 'nav', 'mobile', 'hamburger'])

export const Header: FunctionComponent<HeaderType> = ({...props}) => (
	<Fragment>
		<MediaQuery
			minWidth={1024}
			view={() => (
				<div class={styles}>
					<header class={styles('positioner')}>
						<HeaderLogo />
						<HeaderNav {...props} />
					</header>
				</div>
			)}
		/>
		<MediaQuery maxWidth={1023} view={() => <HeaderMobileNav {...props} />} />
	</Fragment>
)

export const HeaderLogo: FunctionComponent<{className?: string}> = ({
	className = null
}) => {
	const language = useLanguage()

	return (
		<Link to={language ? `/${language}` : '/'} class={styles.logo}>
			<LogoNl />
		</Link>
	)
}

export const HeaderNav: FunctionComponent<HeaderType> = ({
	menu,
	primary,
	secondary
}) => {
	return (
		<nav class={styles.nav}>
			<div class={styles.nav('container')}>
				{menu &&
					menu.length > 0 &&
					menu.map((item) => (
						<NavItem
							exact
							class={styles.nav('link')}
							type="entry"
							to={item.url}
						>
							{item.description ? item.description : item.title}
						</NavItem>
					))}
			</div>
			<div class={styles.nav('buttoncontainer')}>
				{primary && (
					<ButtonPrimary
						type={primary.type}
						to={primary.url}
						target={primary.target}
						id="gift-header"
					>
						{primary.description ? primary.description : primary.title}
					</ButtonPrimary>
				)}
				{secondary && (
					<ButtonSecondary
						type={primary.type}
						to={secondary.url}
						target={secondary.target}
						id="register-header"
					>
						{secondary.description ? secondary.description : secondary.title}
					</ButtonSecondary>
				)}
			</div>
		</nav>
	)
}

export const HeaderMobileNav: React.FC<HeaderType> = ({
	menu,
	primary,
	secondary
}) => {
	const [isOpen, setOpen] = useState(false)

	useEffect(() => {
		const bodyStyle = document.body.style
		if (isOpen) bodyStyle.overflowY = 'hidden'
		else bodyStyle.overflowY = 'auto'
	}, [isOpen])
	const {ref} = useAutohide(isOpen)
	return (
		<header className={styles} ref={ref}>
			<HeaderPopup toggled={isOpen} toggle={setOpen}>
				<div className={styles.nav.is({open: isOpen})}>
					<div onClick={() => setOpen(false)}>
						<HeaderLogo className={styles.nav('logo')} />
					</div>
					<div className={styles.nav('items')}>
						{menu.map((link) => (
							<NavItem to={link.url} onClick={() => setOpen(false)}>
								{link.description ? link.description : link.title}
							</NavItem>
						))}
					</div>
					<div class={styles('button')}>
						{primary && (
							<ButtonPrimary to={primary.url} onClick={() => setOpen(false)}>
								{primary.description ? primary.description : primary.title}
							</ButtonPrimary>
						)}
					</div>
					<div class={styles('button')}>
						{secondary && (
							<ButtonSecondary
								to={secondary.url}
								onClick={() => setOpen(false)}
							>
								{secondary.description
									? secondary.description
									: secondary.title}
							</ButtonSecondary>
						)}
					</div>
				</div>
			</HeaderPopup>
		</header>
	)
}
